window.UpdateMemberPhoneNumberForm = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            textBox: {
                phoneNumber: '#member-phone-number-phone-number'
            },
            button: {
                savePhoneNumber: '#save-phone-Number',
            },
            form:{
                phoneNumberForm:'#member-phone-number-form'
            }
        },
        urls: {
            sendOtpToEmailUrl:'/api/sitecore/UpdateMemberZonePhoneNumber/TriggerOtpToEmail',
            emailOtpVerificationPageUrl : '/my-account/details/phone/update-memberzone-phone-number/email-otp-verification',
            errorPageUrl: '/error/error-page'
        },
        css: {
            invalidFormInput: 'vds-form__input--invalid'
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.form.phoneNumberForm).on('submit', self.func.handleSavePhoneNumber);
            },
            handleSavePhoneNumber: function (event) {
                event.preventDefault();
                //trigger otp request to email
                $.ajax({
                    type: 'PATCH',
                    url: self.urls.sendOtpToEmailUrl,
                    data:{ MemberPhoneNumber: $(self.elements.textBox.phoneNumber).val().trim() },
                    success: function(response) {
                        const isAccepted = response.statusCode?.toLowerCase() === self.statusDescription.accepted;
                        window.location.href = isAccepted ? self.urls.emailOtpVerificationPageUrl : self.urls.errorPageUrl;
                    },
                    error: function() {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            },
        }
    };

    return {
        Init: self.func.init
    };
}) ();

$(document).ready(function () {
    if ('member-phone-number-form' === $('#member-phone-number-form').data('feature')) {
        window.UpdateMemberPhoneNumberForm.Init();
    }
});
